import { GetOrganizerBalanceResponse } from "@smatchy/sdk";

export class GetBalances {
    static readonly type = '[Balances] Get Balances';
    constructor() {}
}
export class GetBalancesSuccess {
    static readonly type = '[Balances] Get Balances Success';
    constructor(public payload: GetOrganizerBalanceResponse) {}
}